module.exports = __webpack_public_path__ + "static/img/honor22.43b1e59.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/about/honor/honor22.png
// module id = httA
// module chunks = 0